import { all, takeEvery, put } from 'redux-saga/effects'
import { request } from '../../../../admincore'

import { getCards } from '../../api'
import actions from './actions'

// const getCompanySelect = state => state.companySelect

function* LOAD({ payload: { params } }) {
  const companySelect = localStorage.getItem('app.settings.company')

  if (!companySelect || companySelect === -1) {
    return
  }
  yield put(request(getCards(companySelect, params), actions.LOAD))
}

export default function* rootSaga() {
  yield all([takeEvery(actions.LOAD, LOAD)])
}
